export default "__VITE_ASSET__DDK91s1W__"